import { TranslationGroup } from '../../i18n';
import { httpConstants } from '../http-constants';
import { en } from './en';
import { zh } from './zh';


export const mmHttpTranslationGroup = {
    groupName: httpConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup;